import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AccountDisplayNamePipe } from '@shared/pipes/account-display-name.pipe';
import { Account } from '@stores/models/app/account';

@Component({
  selector: 'app-account-signature',
  templateUrl: './account-signature.component.html',
  styleUrls: ['./account-signature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatTooltipModule, AccountDisplayNamePipe]
})
export class AccountSignatureComponent {
  readonly account = input<Account | null>(null);
  readonly onlyAvatar = input(false);
  readonly displayTooltip = input(true);
}
